export default "__VITE_ASSET__CLJwLpuU__"